import { AiPart } from "@intelligems/ig-types/schemas/ai/ui-message-part";
import { PickType } from "@intelligems/ig-types/utils";

import { getToolStep } from "@src/features/ai/utils/thought-process-steps";

import { WithDebugMessages } from "./WithDebugMessages";
import { WorkLogRow } from "./WorkLogRow";

import {
  FlattenedPart,
  MessageFlags,
} from "@src/features/ai/components/WorkflowEditor/execution/types";

type ToolCallMessageProps = {
  item: FlattenedPart;
  part: PickType<AiPart, "dynamic-tool">;
} & MessageFlags;

/**
 * A tool call drawn as a work-log action row on its own. Steps normally render
 * inside `ThoughtProcessGroup`, which groups every tool call of a run; this is
 * the same row for a call reached outside a group.
 */
export const DynamicTasks = ({ item, part, debug }: ToolCallMessageProps) => {
  if (!part) {
    return null;
  }

  return (
    <WithDebugMessages item={item} part={part} debug={debug}>
      <WorkLogRow
        kind="action"
        label={getToolStep(part.toolName, part.input).title}
      />
    </WithDebugMessages>
  );
};
